import {
  PHONE_CASE_CATEGORY,
  DEVICES,
} from '../../../Products/data/phoneCaseFilters';

export function getData(arg = 1) {
  const phoneCaseMenu = [
    [
      [PHONE_CASE_CATEGORY, ...DEVICES],
    ],
  ];

  // All menu slots use the phone-case device list
  return phoneCaseMenu;
}
